// ─── WEARABLES DATA ────────────────────────────────────────────────────────
// To add images: replace null with your image URL, e.g.:
//   image: '/images/galaxy-watch8.jpg'      ← file in /public/images/
//   image: 'https://yourcdn.com/watch.png'  ← external URL

export const WEARABLES = [
  // ── SMARTWATCHES ──────────────────────────────────────────────────────────
  {
    id: 1, brand: 'Samsung', name: 'Galaxy Watch Ultra 2025 eSIM', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/c642ef6b045445017a911ad5914d652c.png',                   // ← ADD IMAGE URL HERE
    badge:  '',
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 299, wasPrice: null, save: null, term: 36, prepaid: 8899,
  },
  {
    id: 2, brand: 'Samsung', name: 'Galaxy Watch8 Classic eSIM', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/2e3a7ccca44432f9b065040dffa9efee.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 259, wasPrice: null, save: null, term: 36, prepaid: 7609,
  },
  {
    id: 3, brand: 'Samsung', name: 'Galaxy Watch8 eSIM', type: 'Smartwatch',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 149, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 4, brand: 'Apple', name: 'Watch Ultra 3 GPS+Cellular 49mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/07ef205430af9df2ec308d3087eb4c59.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 489, wasPrice: null, save: null, term: 36, prepaid: 16999,
  },
  {
    id: 5, brand: 'Apple', name: 'Watch Series 11 GPS+Cellular 42mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/ad56ec6e5948fa4227d0059404d09549.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 369, wasPrice: null, save: null, term: 36, prepaid: 10999,
  },
  {
    id: 6, brand: 'Apple', name: 'Watch Series 11 GPS 46mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/2b68c965a4c1d3bb13c1099868510d08.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 289, wasPrice: null, save: null, term: 36, prepaid: 8499,
  },
  {
    id: 7, brand: 'Apple', name: 'Watch SE3 GPS 44mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/85ac945a30a105ab3e902077d921a6cf.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 199, wasPrice: null, save: null, term: 36, prepaid: 5999,
  },
  {
    id: 8, brand: 'Apple', name: 'Watch SE3 GPS 40mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/85ac945a30a105ab3e902077d921a6cf.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 179, wasPrice: null, save: null, term: 36, prepaid: 5299,
  },
  {
    id: 9, brand: 'HONOR', name: 'Watch 5 Ultra', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/413651edff7272f23de9826ca47071f9.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 169, wasPrice: null, save: null, term: 36, prepaid: 5379,
  },
  {
    id: 10, brand: 'HONOR', name: 'Watch 5', type: 'Smartwatch',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 99, wasPrice: null, save: null, term: 36, prepaid: 3059,
  },
  {
    id: 11, brand: 'HONOR', name: 'Watch 2i', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/a62774260d59bee128e0dcbabc657506.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 29, wasPrice: null, save: null, term: 36, prepaid: 939,
  },
  {
    id: 12, brand: 'HUAWEI', name: 'Watch Ultimate Pro 2', type: 'Smartwatch',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 489, wasPrice: null, save: null, term: 36, prepaid: 15799,
  },
  {
    id: 13, brand: 'HUAWEI', name: 'Watch GT Runner 2', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/940fccbaded9e48899a7356783350ae9.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 199, wasPrice: null, save: null, term: 36, prepaid: 7499,
  },
  {
    id: 14, brand: 'HUAWEI', name: 'Watch GT6 Pro Titanium 46mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/995ed1dda7676c74f047265beff94534.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 199, wasPrice: null, save: null, term: 36, prepaid: 8919,
  },
  {
    id: 15, brand: 'HUAWEI', name: 'Watch GT6 46mm', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/8e3b20619e1776ab4af7aac744ecec7c.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 159, wasPrice: null, save: null, term: 36, prepaid: 4399,
  },
  {
    id: 16, brand: 'OPPO', name: 'Watch X2', type: 'Smartwatch',
    image: 'https://cdn-vodacom.pubhub.studio/0d4aa400bdef0d29b5a7041f6fb531dc.png',                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 129, wasPrice: null, save: null, term: 36, prepaid: 5779,
  },

  // ── FITNESS BANDS ─────────────────────────────────────────────────────────
  {
    id: 20, brand: 'Samsung', name: 'Galaxy Fit3', type: 'Fitness Band',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 39, wasPrice: null, save: null, term: 36, prepaid: 1099,
  },
  {
    id: 21, brand: 'HUAWEI', name: 'Fit4 Pro', type: 'Fitness Band',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 149, wasPrice: null, save: null, term: 36, prepaid: 4669,
  },
  {
    id: 22, brand: 'HUAWEI', name: 'Fit4', type: 'Fitness Band',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 99, wasPrice: null, save: null, term: 36, prepaid: 2999,
  },
  {
    id: 23, brand: 'HUAWEI', name: 'Band 11 Pro', type: 'Fitness Band',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 49, wasPrice: null, save: null, term: 36, prepaid: 1499,
  },
  {
    id: 24, brand: 'HUAWEI', name: 'Band 11', type: 'Fitness Band',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 39, wasPrice: null, save: null, term: 36, prepaid: 1099,
  },

  // ── EARBUDS ───────────────────────────────────────────────────────────────
  {
    id: 30, brand: 'Apple', name: 'AirPods Pro 3', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 169, wasPrice: null, save: null, term: 36, prepaid: 5399,
  },
  {
    id: 31, brand: 'Apple', name: 'AirPods 4 ANC', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 129, wasPrice: null, save: null, term: 36, prepaid: 3899,
  },
  {
    id: 32, brand: 'Apple', name: 'AirPods 4', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 89, wasPrice: null, save: null, term: 36, prepaid: 2699,
  },
  {
    id: 33, brand: 'Samsung', name: 'Galaxy Buds4 Pro', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 129, wasPrice: null, save: null, term: 36, prepaid: 3999,
  },
  {
    id: 34, brand: 'Samsung', name: 'Galaxy Buds4', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 99, wasPrice: null, save: null, term: 36, prepaid: 2799,
  },
  {
    id: 35, brand: 'HUAWEI', name: 'Freebuds Pro 5', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 109, wasPrice: null, save: null, term: 36, prepaid: 3199,
  },
  {
    id: 36, brand: 'HUAWEI', name: 'Freeclip 2', type: 'Earbuds',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 99, wasPrice: null, save: null, term: 36, prepaid: 3799,
  },

  // ── GAMING ────────────────────────────────────────────────────────────────
  {
    id: 40, brand: 'Sony', name: 'PlayStation 5 Pro Edition', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 669, wasPrice: null, save: null, term: 36, prepaid: 19449,
  },
  {
    id: 41, brand: 'Sony', name: 'PlayStation 5 Disc Slim', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 479, wasPrice: null, save: null, term: 36, prepaid: 13929,
  },
  {
    id: 42, brand: 'Sony', name: 'PlayStation 5 Digital', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 379, wasPrice: null, save: null, term: 36, prepaid: 12829,
  },
  {
    id: 43, brand: 'Microsoft', name: 'XBOX Series S 1TB + Controller + Headset', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 529, wasPrice: null, save: null, term: 36, prepaid: 14999,
  },
  {
    id: 44, brand: 'Nintendo', name: 'Switch 2 + Mario Kart World Bundle', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 449, wasPrice: null, save: null, term: 36, prepaid: 13449,
  },
  {
    id: 45, brand: 'Nintendo', name: 'Switch OLED', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 319, wasPrice: null, save: null, term: 36, prepaid: 9509,
  },
  {
    id: 46, brand: 'Lenovo', name: 'Legion Go S Stream', type: 'Gaming',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'ADD-ON', data: null, minutes: null, onceOff: null,
    price: 419, wasPrice: null, save: null, term: 36, prepaid: 12929,
  },
];

export const WEARABLE_TYPES = ['All', 'Smartwatch', 'Fitness Band', 'Earbuds', 'Gaming'];
export const WEARABLE_BRANDS = ['All', ...new Set(WEARABLES.map(w => w.brand))];
